import FinalLapCounterScreen from './FinalLapCounterScreen';

export default FinalLapCounterScreen;